import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import reactHotToast from 'react-hot-toast';
import { ErrorIcon, SuccessIcon } from '../../icons';
import { useTheme } from '../../theme';
import useToastStyles from './Toast.Styles';
const ErrorToast = ({ text, component }) => {
    const theme = useTheme();
    const styles = useToastStyles({ theme });
    return (_jsx(_Fragment, { children: _jsxs("div", { className: styles.base + ' ' + styles.error, children: [_jsx("div", { className: styles.baseLine + ' ' + styles.errorLine }), component ? (component) : (_jsxs(_Fragment, { children: [_jsx(ErrorIcon, {}), _jsx("span", { children: text })] }))] }) }));
};
const SuccessToast = ({ text, component }) => {
    const theme = useTheme();
    const styles = useToastStyles({ theme });
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.base + ' ' + styles.success, children: [_jsx("div", { className: styles.baseLine + ' ' + styles.successLine }), component ? (component) : (_jsxs(_Fragment, { children: [_jsx(SuccessIcon, {}), _jsx("span", { children: text })] }))] }), component ? component : null] }));
};
const InfoToast = ({ text, component }) => {
    const theme = useTheme();
    const styles = useToastStyles({ theme });
    return (_jsx(_Fragment, { children: _jsxs("div", { className: styles.base + ' ' + styles.info, children: [_jsx("div", { className: styles.baseLine + ' ' + styles.infoLine }), component ? component : _jsx("span", { children: text })] }) }));
};
const WarningToast = ({ text, component }) => {
    const theme = useTheme();
    const styles = useToastStyles({ theme });
    return (_jsx(_Fragment, { children: _jsxs("div", { className: styles.base + ' ' + styles.warning, children: [_jsx("div", { className: styles.baseLine + ' ' + styles.warningLine }), component ? component : _jsx("span", { children: text })] }) }));
};
export const toast = ({ text, variant, component, duration }) => {
    switch (variant) {
        case 'error':
            return reactHotToast.custom(() => _jsx(ErrorToast, { text: text, component: component }), { duration });
        case 'success':
            return reactHotToast.custom(() => _jsx(SuccessToast, { text: text, component: component }), { duration });
        case 'info':
            return reactHotToast.custom(() => _jsx(InfoToast, { text: text, component: component }), { duration });
        case 'warning':
            return reactHotToast.custom(() => _jsx(WarningToast, { text: text, component: component }), { duration });
    }
};
export default toast;
export function removeToast(id) {
    reactHotToast.remove(id);
}
